<template>
  <div>
      <v-tabs light grow>
        <v-tabs-slider color="light-blue lighten-2"></v-tabs-slider>
        <v-tab href="#tab-1">Care User Profile</v-tab>
        <v-tab href="#tab-2">Alert History</v-tab>
        <v-tab href="#tab-3">Threshold</v-tab>
        <!--<v-tab href="#tab-4">Reports</v-tab>-->
        <v-tab-item :id="'tab-1'"><care-user-tab-profile></care-user-tab-profile></v-tab-item>
        <v-tab-item :id="'tab-2'"><care-user-tab-alert-history></care-user-tab-alert-history></v-tab-item>
        <v-tab-item :id="'tab-3'"><care-user-tab-threshold></care-user-tab-threshold></v-tab-item>
        <!--<v-tab-item :id="'tab-4'"><care-user-tab-reports></care-user-tab-reports></v-tab-item>-->
      </v-tabs>
  </div>
</template>

<script>
  import CareUserTabProfile from '@/components/CareUser/CareUserTabProfile.vue'
  import CareUserTabAlertHistory from '@/components/CareUser/CareUserTabAlertHistory.vue'
  import CareUserThreshold from '@/components/CareUser/CareUserThreshold.vue'

  export default {
    components: {
      'care-user-tab-profile': CareUserTabProfile,
      'care-user-tab-alert-history': CareUserTabAlertHistory,
      'care-user-tab-threshold': CareUserThreshold
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CareUser/CareUserEdit.vue